<template>
    <div class="catalog-vue">
        <!-- Sidebar Navigate -->
        <bo-catalog-sidebar
            :categories="categories"
            :loading="categoriesLoading"
            :class="{ 'fixed-sidebar': fixedSidebar }"
            @select-category="selectProductCategory"
            :current-category-id="currentCategoryId"
        ></bo-catalog-sidebar>

        <!-- Catalog Product -->
        <div
            class="catalog-list"
            :class="{ 'fixed-sidebar': fixedSidebar }"
            id="catalog-list"
        >
            <div class="catalog-header">
                <div class="left-panel">
                    <div class="title">{{ categoryTitle }}</div>
                    <div class="subtitle">{{ foundText }}</div>
                </div>

                <!-- Filter product for future development -->
                <!-- <div class="right-panel">
                    <div class="sorting">
                        <span class="theme-primary-color">Sort By</span>
                        <select name="" id="" class="form-control">
                            <option value="">Name</option>
                            <option value="">SKU</option>
                            <option value="">Product Quantity (Low to High)</option>
                            <option value="">Product Quantity (High to Low)</option>
                        </select>
                    </div>
                    <div class="filter">
                        <i class="icon-filteralt"></i>
                    </div>
                </div> -->
            </div>

            <bo-related-categories v-if="isSearching"></bo-related-categories>

            <!-- INCOTERM -->
            <!-- <div class="incoterm-header">
                <bo-dropdown dropdown-title="Incoterm type">
                    <template #menu-item></template>
                </bo-dropdown>

                <bo-dropdown dropdown-title="From">
                    <template #menu-item></template>
                </bo-dropdown>

                <bo-dropdown dropdown-title="To">
                    <template #menu-item></template>
                </bo-dropdown>
            </div> -->

            <div class="bo-catalog-list">
                <div
                    class="product-listing grid"
                    v-if="products.data?.length > 0"
                >
                    <div
                        class="product-item"
                        v-for="(product, index) in products.data"
                        :key="product.index"
                        v-if="
                            product.catalog_visibility &&
                            (categoryIdNum === null ||
                                categoryIdNum > 0 ||
                                isFrequentlyPurchased ||
                                (isFavourites && product.favorited))
                        "
                    >
                        <a
                            v-if="!isReturnMode"
                            class="product-info"
                            :href="product.product_details_url"
                        >
                            <div class="info-left">
                                <div class="image">
                                    <img
                                        :src="product.images"
                                        class="image-img"
                                        alt="image"
                                        @error="showPlaceholderImage"
                                    />
                                    <div class="image-overlay"></div>
                                    <i
                                        v-if="enabledFavoriteProduct"
                                        :class="[
                                            'favorite-icon',
                                            product.favorited ? 'icon-favoritefilled' : 'icon-favorite',
                                            { 'is-favorited': product.favorited },
                                        ]"
                                        @click.stop.prevent="
                                            product.favorited = !product.favorited;
                                            favoriteProduct(product, index);
                                        "
                                    >
                                    </i>

                                    <button
                                        class="catalog-quick-add-button"
                                        @click.stop.prevent="quickAddProduct(product)"
                                    >
                                        <span class="add-plus">+</span>
                                        <span class="add-text">{{ generalTranslations.add_to_cart }}</span>
                                    </button>

                                    <div
                                        v-if="product.is_matrix_product"
                                        class="variation"
                                    >
                                        <div class="title">
                                            {{
                                                generalTranslations.select_object.replace(
                                                    ":object",
                                                    catalogTranslations.variation
                                                ) ?? "Select Variation"
                                            }}
                                        </div>
                                        <div
                                            class="variation-selection"
                                            @click.stop="activateProductMatrixPopup($event, product)"
                                        >
                                            {{
                                                generalTranslations.select_object.replace(
                                                    ":object",
                                                    catalogTranslations.variation
                                                ) ?? "Select Variation"
                                            }}
                                            <i class="icon-chevronright"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="product-details">
                                    <div
                                        class="volume-price-tag"
                                        v-if="product.has_volume_pricing && canReadPrices"
                                    >
                                        <span>{{ catalogTranslations.volume_pricing ?? "Volume Pricing" }}</span>
                                    </div>
                                    <div class="badges">
                                        <span
                                            v-if="product.type == 'bundle'"
                                            class="bundle-badge"
                                            >{{ catalogTranslations.bundle ?? "Bundle" }}</span
                                        >
                                        <span class="sku-product text-break">{{ product.sku }}</span>
                                        <span
                                            v-if="showNoInventoryBadge(product)"
                                            class="in-stock danger"
                                            >{{ noInventoryTextHandler() }}</span
                                        >
                                        <div
                                            v-else-if="
                                                !isEmpty(getProductWarehouseInventory(product)) &&
                                                !product.is_matrix_product &&
                                                product.type != 'bundle' &&
                                                showMinimalistInventory(product)
                                            "
                                            class="in-stock"
                                            :class="getStockClass(product, user_warehouse_inventories)"
                                        >
                                            {{ getProductWarehouseInventory(product) }}
                                        </div>
                                        <div
                                            v-else-if="showMatrixStockBadge(product)"
                                            class="in-stock"
                                            :class="getMatrixStockClass(product)"
                                        >
                                            {{
                                                getMatrixProductStockInStatus(product)
                                                    ? catalogTranslations.in_stock ?? "In Stock"
                                                    : catalogTranslations.out_of_stock ?? "Out of Stock"
                                            }}
                                        </div>
                                        <div
                                            class="sku-backorder"
                                            v-if="getProductAllowBackorder(product) && showMinimalistBackorder(product)"
                                        >
                                            {{ catalogTranslations.backorder ?? "Backorder" }}
                                        </div>
                                    </div>
                                    <div class="product-name">
                                        {{ product.name }}
                                    </div>
                                    <div
                                        v-if="cardSnippets[product.id]"
                                        class="search-description"
                                    >
                                        “{{ cardSnippets[product.id] }}”
                                    </div>
                                    <bo-product-details
                                        class="prod-weight"
                                        :parts="productDetails(product)"
                                    ></bo-product-details>
                                </div>
                            </div>
                            <div class="info-right">
                                <div class="single-count">
                                    <template v-if="canReadPrices">
                                    <bo-price-display
                                        size="medium"
                                        v-bind="getCatalogPriceDisplay(product)"
                                    ></bo-price-display>
                                    </template>
                                    <bo-bundle-deal-link
                                        v-if="product.has_related_bundles && !isReturnMode"
                                        :label="catalogTranslations.available_in_bundle_deal ?? 'Available in a bundle deal'"
                                        @click="$emit('open_related_bundles', product)"
                                    ></bo-bundle-deal-link>
                                    <!-- <div class="point text-14">
                                    <span v-if="(product.discount != null) && (product.discount > 0)">
                                        <i class="icon-bpoint"></i>
                                        +{{ (product.regular_price*((100-product.discount)/100)).toFixed(2) }}PTS
                                    </span>
                                    <span v-else>
                                        <i class="icon-bpoint"></i>
                                      +{{ product.regular_price.toFixed(2) }}PTS
                                    </span>
                                </div> -->
                                    <!-- <div class="quantity">
                                    <select name="uom-select" id="" class="border-right">
                                        <option value="">CTN</option>
                                        <option value="">PACK</option>
                                        <option value="">UOM</option>
                                    </select>
                                    <button class="">
                                        <i class="icon-remove" @click="minusQuantity(product)"></i>
                                    </button>
                                    <input class="theme-primary-color" type="number" min="1"
                                        oninput="this.value = Math.abs(this.value)" v-model.number="product.qty"
                                        @change="calculateTotalPrice(product)" />
                                    <button class="">
                                        <i class="icon-add" @click="addQuantity(product)"></i>
                                    </button>
                                </div> -->
                                </div>

                                <!-- <a :href="product.product_details_url" class="btn-rounded d-flex align-items-center">
                                View Details
                            </a> -->
                            </div>
                        </a>
                        <a
                            v-else
                            @click="activeReturnPopup(product)"
                        >
                            <div class="info-left">
                                <div class="image">
                                    <img
                                        class="image-img"
                                        :src="product.images"
                                        alt="image"
                                        @error="showPlaceholderImage"
                                    />
                                    <div
                                        v-if="product.is_matrix_product"
                                        class="variation"
                                        @click.stop="activateProductMatrixPopup($event, product)"
                                    >
                                        {{
                                            generalTranslations.select_object.replace(
                                                ":object",
                                                catalogTranslations.variation
                                            ) ?? "Select Variation"
                                        }}
                                    </div>
                                </div>
                                <div class="product-details">
                                    <div class="badges">
                                        <span
                                            v-if="product.type == 'bundle'"
                                            class="bundle-badge"
                                            >{{ catalogTranslations.bundle ?? "Bundle" }}</span
                                        >
                                        <span class="sku-product text-break">{{ product.sku }}</span>
                                    </div>
                                    <div class="name">
                                        {{ product.name }}
                                    </div>
                                </div>
                            </div>
                            <div class="info-right">
                                <div class="single-count">
                                    <template v-if="canReadPrices">
                                    <bo-price-display
                                        size="medium"
                                        v-bind="getCatalogPriceDisplay(product)"
                                    ></bo-price-display>
                                    </template>
                                    <div class="product-info">
                                        <bo-product-details
                                            class="prod-weight"
                                            :parts="productDetails(product)"
                                        ></bo-product-details>
                                    </div>
                                    <!-- <div class="point text-14">
                                    <span v-if="(product.discount != null) && (product.discount > 0)">
                                        <i class="icon-bpoint"></i>
                                        +{{ (product.regular_price*((100-product.discount)/100)).toFixed(2) }}PTS
                                    </span>
                                    <span v-else>
                                        <i class="icon-bpoint"></i>
                                      +{{ product.regular_price.toFixed(2) }}PTS
                                    </span>
                                </div> -->
                                    <!-- <div class="quantity">
                                    <select name="uom-select" id="" class="border-right">
                                        <option value="">CTN</option>
                                        <option value="">PACK</option>
                                        <option value="">UOM</option>
                                    </select>
                                    <button class="">
                                        <i class="icon-remove" @click="minusQuantity(product)"></i>
                                    </button>
                                    <input class="theme-primary-color" type="number" min="1"
                                        oninput="this.value = Math.abs(this.value)" v-model.number="product.qty"
                                        @change="calculateTotalPrice(product)" />
                                    <button class="">
                                        <i class="icon-add" @click="addQuantity(product)"></i>
                                    </button>
                                </div> -->
                                </div>

                                <!-- <a :href="product.product_details_url" class="btn-rounded d-flex align-items-center">
                                View Details
                            </a> -->
                            </div>
                        </a>
                    </div>
                </div>

                <!-- pagination starts-->

                <div
                    v-if="
                        (pagination && (categoryIdNum > 0 || categoryIdNum === null)) ||
                        (isFrequentlyPurchased && totalAmount > 0) ||
                        (totalAmount > 0 && (isFavourites || categoryIdNum === null))
                    "
                    class="bo-pagination-footer"
                >
                    <!-- <div class="total">
                        <div class="total-count title">
                            Showing {{ formattedTotal(pagination.from) }} -
                            {{
                                formattedTotal(
                                    (pagination.current_page - 1) * pagination.per_page + products.data.length
                                )
                            }}
                            of {{ formattedTotal(pagination.total) }}
                        </div>
                    </div> -->
                    <div class="pagination">
                        <!-- <div class="rows-per-page">
                            <span> Rows</span>

                            <div class="select-page">
                                <select v-model="limitPerPage">
                                    <option
                                        v-for="(limit, index) in perPage"
                                        :key="index"
                                    >
                                        {{ limit }}
                                    </option>
                                </select>
                            </div>
                        </div> -->
                        <div class="page-navigation">
                            <div class="pages">
                                <span
                                    v-for="(link, index) in pagination.links"
                                    :key="index"
                                    class="page-item"
                                    :class="{ active: link.active }"
                                >
                                    <a
                                        v-if="link.label == 'pagination.next'"
                                        @click="link.url ? getPageNumber(link.url) : undefined"
                                    >
                                        <div class="page-btn page-btn-primary-bg-secondary">
                                            <i class="icon-chevronright"></i>
                                        </div>
                                    </a>

                                    <a
                                        v-else-if="link.label == 'pagination.previous'"
                                        @click="link.url ? getPageNumber(link.url) : undefined"
                                    >
                                        <div class="page-btn page-btn-primary-bg-secondary">
                                            <i class="icon-chevronleft"></i>
                                        </div>
                                    </a>

                                    <a
                                        v-else
                                        class="pagination-txt"
                                        @click="link.url ? getPageNumber(link.url) : undefined"
                                    >
                                        {{ link.label }}
                                    </a>
                                </span>
                            </div>
                            <div class="go-to">
                                <span>{{ generalTranslations.page ?? "Page" }}</span>
                                <input
                                    type="number"
                                    v-model="pageNumber"
                                />
                                <button
                                    class="btn-go"
                                    @click="selectPage(pageNumber, pagination.links)"
                                    :disabled="pageNumber == '' || pageNumber > pagination.last_page"
                                >
                                    {{ generalTranslations.go ?? "Go" }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- pagination ends -->

                <div
                    class="empty-wrapper"
                    :class="{ 'empty-wrapper-compact': isFrequentlyPurchased || isFavourites }"
                    v-else-if="productsLoaded"
                >
                    <div class="image">
                        <bo-svg
                            :svg-content="
                                enabledFavoriteProduct || isFrequentlyPurchased
                                    ? '/assets/graphics/img_empty.svg'
                                    : '/assets/graphics/img-search.svg'
                            "
                            :primary-color="primaryColor"
                        ></bo-svg>
                    </div>
                    <div
                        v-if="isFrequentlyPurchased"
                        class="title"
                    >
                        {{ catalogTranslations.no_frequently_purchased ?? "No frequently purchased items yet" }}
                    </div>
                    <div
                        v-if="isFrequentlyPurchased"
                        class="description"
                    >
                        {{
                            catalogTranslations.no_frequently_purchased_description ??
                            "Products you often order will appear here for quick reordering."
                        }}
                    </div>
                    <div
                        v-if="enabledFavoriteProduct && isFavourites"
                        class="title"
                    >
                        {{ catalogTranslations.no_favorite ?? "No favourites yet" }}
                    </div>
                    <div
                        v-if="enabledFavoriteProduct && isFavourites"
                        class="description"
                    >
                        {{
                            catalogTranslations.no_favorite_description ??
                            "To add an item, click the heart icon on any product."
                        }}
                    </div>
                </div>
            </div>
        </div>
        <bo-popup-modal
            class="catalog-popup"
            :no-title="true"
            modal-style="has-table"
            :active="activeProductMatrixPopup"
            :keep-alive="true"
            :show-modal-footer="false"
            @deactivate="activeProductMatrixPopup = false"
            @trigger="productMatrixAddToCart = true"
        >
            <template #body-content>
                <bo-product-matrix
                    :add-to-cart-prop="productMatrixAddToCart"
                    :product="matrixProduct"
                    :is-popup="true"
                    @deactivate="activeProductMatrixPopup = false"
                    @added_to_cart_or_error="
                        productMatrixAddToCart = false;
                        activeProductMatrixPopup = false;
                    "
                >
                </bo-product-matrix>
            </template>
        </bo-popup-modal>
    </div>
</template>

<script>
Vue.component("bo-svg", require("js/frontend/components/bo-svg.vue").default);
Vue.component("bo-related-categories", require("js/frontend/components/bo-related-categories.vue").default);
Vue.component("bo-product-details", require("js/frontend/components/bo-product-details.vue").default);
import Vue from "vue";
import httpMixin from "@/v2/mixins/http.js";
import productMixin from "@/v2/mixins/products.js";
import BoPoint from "js/frontend/components/bo-point.vue";
import { ReturnPopup } from "@/v2/models/bo-return-popup.js";
import { returnPopupMixin } from "@/v2/mixins/bo-return-popup.js";
import * as utils from "@/v2/utils/utilities.js";
import { buildCatalogPriceDisplay } from "js/frontend/utils/catalog-price-display.js";
import { searchWords, descriptionSnippet } from "js/frontend/utils/search-text.js";
import { productDetailParts } from "js/frontend/utils/product-details.js";
import { showPlaceholderImage } from "js/frontend/utils/product-image.js";
import { shouldShowNoInventoryBadge, shouldShowMatrixStockBadge } from "js/frontend/utils/stock-badge.js";

Vue.component("bo-point", BoPoint);
Vue.component("bo-line-discount", require("js/frontend/components/bo-line-discount.vue").default);
Vue.component("bo-price-display", require("js/frontend/components/bo-price-display.vue").default);
Vue.component("bo-bundle-deal-link", require("js/frontend/components/bo-bundle-deal-link.vue").default);
Vue.component("bo-popup-modal", require("@/v2/components/bo-popup-modal.vue").default);
Vue.component("bo-catalog-sidebar", require("js/frontend/components/bo-catalog-sidebar.vue").default);
Vue.component("bo-product-matrix", require("@/v2/components/product/bo-product-matrix.vue").default);

import boDropdown from "js/frontend/components/bo-dropdown.vue";
Vue.component("bo-dropdown", boDropdown);

export default {
    components: {
        BoPoint,
    },

    mixins: [returnPopupMixin, httpMixin, productMixin],
    props: {
        products: {
            type: Object,
            default: () => {},
        },
        // #111887: false while the inventories request is still in flight, so the
        // red "no inventory" fallback doesn't flash on every category switch.
        inventoriesLoaded: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: "",
        },
        categories: {
            type: Array,
            default: "",
        },
        catalogUrl: {
            type: String,
        },
        categoryid: {
            type: Number,
            default: null,
        },
        pointConfig: {
            type: [Object, Boolean],
            default: null,
        },
        isReturnMode: {
            type: Boolean,
            default: false,
        },
        taxIncluded: {
            type: Boolean,
            default: false,
        },
        weightUnit: {
            type: String,
            default: "",
        },
        displayPricesDuringCartAndCheckoutIncludingTax: {
            type: Boolean,
            default: false,
        },
        taxExempted: {
            type: Boolean,
            default: false,
        },
        hasCapabilityPhysical: {
            type: Boolean,
            default: false,
        },
        // Price gate — see can_read_prices(). Defaults open so an un-passed prop is a no-op.
        canReadPrices: {
            type: Boolean,
            default: true,
        },
        hasCapabilitySellable: {
            type: Boolean,
            default: false,
        },
        hasCapabilityRoughSellable: {
            type: Boolean,
            default: false,
        },
        user_warehouse_inventories: {
            type: Object,
        },
        roughStockText: {
            type: String,
        },
        hasWarehouse: {
            type: Boolean,
            default: false,
        },
        currentCategoryId: {
            type: Number,
            default: null,
        },
        categoriesLoading: {
            type: Boolean,
            default: false,
        },
        isSearching: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            primaryColor: window.bo_primary_color || '#594c45',
            returnPopup: null,
            currentUrl: null,
            windowSize: {
                width: 0,
                height: 0,
            },
            pageNumber: "",
            fixedSidebar: false,
            sidebarNaturalTop: null,
            activeProductMatrixPopup: false,
            productMatrixAddToCart: false,
            matrixProduct: null,
            show_variation: false,
            hideLineItemTax: window.bo?.hideLineItemTax ?? false,
            hoverProductId: 0,
            generalTranslations: window.bo?.generalTranslations ?? {},
            catalogTranslations: window.bo?.catalogTranslations ?? {},
            currencySymbol: window.bo?.currencySymbol ?? {},
            enabledFavoriteProduct: window.bo?.enabledFavoriteProduct ?? false,
            roughStocks: window.bo.roughStocks,
        };
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
    },
    computed: {
        categoryIdNum() {
            return this.currentCategoryId === null || this.currentCategoryId === undefined
                ? null
                : Number(this.currentCategoryId);
        },
        isFavourites() {
            return this.categoryIdNum === -1;
        },
        isFrequentlyPurchased() {
            return this.categoryIdNum === -2;
        },
        // The page boots with an empty array; the API paginator carries a numeric total.
        productsLoaded() {
            return typeof this.products?.total === "number";
        },
        totalAmount: function () {
            return this.products?.total ?? 0;
        },

        foundText() {
            if (this.isSearching) {
                return (this.catalogTranslations.amount_products_found ?? ":amount products found").replace(
                    ":amount",
                    this.totalAmount
                );
            }

            return (this.catalogTranslations.amount_items_found ?? ":amount items found").replace(
                ":amount",
                this.totalAmount
            );
        },

        // search results only: description snippet per product whenever Description was searched and it matches
        cardSnippets() {
            const context = window.bo?.searchContext;
            if (!this.isSearching || !context?.fields?.includes("description")) return {};

            const words = searchWords(context.query);
            return Object.fromEntries(
                (this.products?.data ?? []).map((product) => [
                    product.id,
                    descriptionSnippet(product.description, words),
                ])
            );
        },

        pagination: function () {
            const meta = Object.assign({}, this.products);
            delete meta.data;
            return meta;
        },

        categoryById() {
            const categoryMap = {};
            const addCategories = (categories) => {
                for (const category of Object.values(categories ?? [])) {
                    categoryMap[category.id] = category;
                    if (category.children?.length) {
                        addCategories(category.children);
                    }
                }
            };

            addCategories(this.categories);

            return categoryMap;
        },

        categoryTitle() {
            if (this.isSearching) {
                return this.title;
            }

            return this.categoryById?.[this.currentCategoryId]?.name || "";
        },

        showMinimalistStock() {
            return !(
                this.hasCapabilityPhysical ||
                this.hasCapabilitySellable ||
                this.hasCapabilityRoughSellable ||
                !this.hasWarehouse
            );
        },
    },
    created() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        showPlaceholderImage,

        ...utils,

        handleScroll() {
            const scrollY = window.scrollY;
            const windowHeight = window.innerHeight;
            const headerHeight = document.getElementById("login-app").offsetHeight;

            document.documentElement.style.setProperty("--fixed-header-height", `${Math.ceil(headerHeight)}px`);

            const sidebar = this.$el.querySelector(".bo-catalog-sidebar");
            if (sidebar && !this.fixedSidebar) {
                this.sidebarNaturalTop = sidebar.getBoundingClientRect().top + scrollY;
            }

            const sidebarReachedHeader =
                this.sidebarNaturalTop !== null && this.sidebarNaturalTop - scrollY <= headerHeight + 24;

            if (document.getElementById("home-footer")) {
                const footerHeight = document.getElementById("home-footer").offsetHeight;
                const isFooterVisible = scrollY + windowHeight >= document.body.offsetHeight - footerHeight;
                this.fixedSidebar = sidebarReachedHeader && !isFooterVisible;
            } else {
                this.fixedSidebar = sidebarReachedHeader;
            }
        },
        // amountOfProducts(products) {
        //     var amount = 0;
        //     products.forEach((product) => {
        //         amount++;
        //     });
        //     return amount;
        // },
        // computeTotal(products) {
        //     var total = 0;
        //     products.forEach((product) => {
        //         total += product.qty * product.price;
        //     });
        //     return total.toFixed(2);
        // },
        // addQuantity(product) {
        //     product.qty++;
        //     this.calculateTotalPrice(product);
        //     return product;
        // },
        // minusQuantity(product) {
        //     if (product.qty > 1) {
        //         product.qty--;
        //     }
        //     this.calculateTotalPrice(product);
        //     return product;
        // },
        // calculateTotalPrice(product) {
        //     if (product.qty > 0) {
        //         return (product.qty * product.price).toFixed(2);
        //     }
        //     return 0;
        // },
        // deleteEvent: function (product) {
        //     this.products.splice(this.products.indexOf(product), 1);
        // },

        formattedTotal(total) {
            if (total) {
                return parseFloat(total)
                    .toFixed(0)
                    .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
            } else {
                return 0;
            }
        },

        getProducts(url) {
            // extract the page number from the url
            this.getData(
                url,
                null,
                (response) => {
                    // this.products = response.data.data;
                },
                (error) => {
                    // handles any error
                }
            );
        },

        goToPage(links) {
            // if the page number is empty, do nothing
            if (this.pageNumber == "") {
                return;
            }

            // links is an object, we need to find the url for the page number
            Object.values(links).forEach((link) => {
                if (link.url != null) {
                    const urlPageNumber = link.url.split("page=")[1];
                    if (urlPageNumber == this.pageNumber) {
                        window.location.assign(link.url);
                        return;
                    }
                }
            });
        },

        handleResize() {
            this.windowSize.width = window.innerWidth;
            this.windowSize.height = window.innerHeight;
        },
        calculatePoint(productPrice) {
            return (
                Math.round(
                    parseFloat(this.pointConfig.tier_multiplier) * productPrice * this.pointConfig.conversion_rate * 100
                ) / 100
            );
        },
        isCurrentUrl(url) {
            let currentUrl = window.location.href;
            let text = currentUrl.substr(currentUrl.indexOf("category/") + 9);
            let textId = text.split("#")[0];
            return textId == url;
        },
        hasParent(items) {
            // console.log(items);
            // let currentUrl = window.location.href;
            let count = 0;
            let currentCategoryId = this.currentCategoryId;

            items.forEach(function (e) {
                // let text = currentUrl.substr(currentUrl.indexOf("category/") + 9);
                // let textId = text.split("#")[0];
                // let url = "category/" + e.id;
                // console.log(textId);
                // console.log(e.id);
                // console.log(e.id == textId);
                if (e.id == currentCategoryId) {
                    count += 1;
                }
            });
            if (count > 0) {
                return true;
            }
        },
        hasNestedParent(grandpa, parent, items) {
            let currentUrl = window.location.href;
            let count = 0;
            items.forEach(function (e) {
                let text = currentUrl.substr(currentUrl.indexOf("category/") + 9);
                let textId = text.split("#")[0];
                let url = "category/" + e.id;
                // console.log(e.id+'->'+e.parent_id+'->'+grandpa);
                if (e.id == textId) {
                    count += 1;
                }
            });
            if (count > 0) {
                // let grandpaId = '#cate-'+grandpa;
                // // console.log(grandpaId);
                // $("#cate-7").css("display", "block");
                return true;
            }
        },
        hasGrandson(items) {
            // console.log(items);
            // let currentUrl = window.location.href;
            let count = 0;
            let currentCategoryId = this.currentCategoryId;

            items.forEach(function (e) {
                e.children.forEach((ex) => {
                    // let text = currentUrl.substr(currentUrl.indexOf("category/") + 9);
                    // let textId = text.split("#")[0];
                    // let url = "category/" + ex.id;
                    if (ex.id == currentCategoryId) {
                        count += 1;
                    }
                });
            });
            if (count > 0) {
                return true;
            }
        },
        // async activeReturnPopup(product) {
        //     // const returnPopup = new ReturnPopup(product);
        //     await this.$parent.$refs["bo_return_popup"].activate(product);
        //     // this.boReturnPopup(returnPopup);
        // },
        activeReturnPopup(product) {
            this.$emit("active_return_popup", product);
        },
        productDetails(product) {
            if (product.type == "bundle") return [];

            return productDetailParts(product.type == "variable" ? this.selectProduct(product) : null, {
                units: {
                    kg: window.bo.generalTranslations.kg,
                    m: window.bo.generalTranslations.m,
                    m3: window.bo.generalTranslations.m3,
                },
                format: (value) => this.toFixedNumber(value),
            });
        },
        selectProduct(product) {
            let selectedProduct = null;

            if (!this.isEmpty(product?.default_variation) && !product?.default_variation?.hide) {
                selectedProduct = product?.default_variation;
            } else if (!this.isEmpty(product?.base_variation) && !product?.base_variation?.hide) {
                selectedProduct = product?.base_variation;
            } else if (!this.isEmpty(product?.variations) && !this.isEmpty(product?.base_variation?.id)) {
                selectedProduct = product?.variations.find((v) => v.id !== product?.base_variation?.id && !v.hide);
            } else if (!this.isEmpty(product?.variations)) {
                selectedProduct = product?.variations.find((v) => !v.hide) || product?.variations[0] || null;
            }

            if (this.isEmpty(selectedProduct) && !this.isEmpty(product?.variations)) {
                selectedProduct = product?.variations.find((v) => !v.hide) || product?.variations[0] || null;
            }

            return selectedProduct;
        },
        // If for the product has no inventory, handling based different user capabilities
        noInventoryTextHandler() {
            if (!window.bo.hasWarehouse) return "";
            if (window.bo.hasCapabilityPhysical) return window.bo.catalogTranslations.physical;
            if (window.bo.hasCapabilitySellable) return window.bo.catalogTranslations.sellable;
            if (window.bo.hasCapabilityRoughSellable) return window.bo.roughStockText;
            return window.bo.catalogTranslations.physical.out_of_stock;
        },

        productInventoryExists(productId) {
            return this.user_warehouse_inventories[productId] == null ? false : true;
        },

        // #111887: the red fallback badge, gated so it never flashes while the
        // inventories request is still in flight. Logic lives in
        // js/frontend/utils/stock-badge.js so it is unit-testable.
        showNoInventoryBadge(product) {
            return shouldShowNoInventoryBadge({
                inventoriesLoaded: this.inventoriesLoaded,
                inventoryExists: this.productInventoryExists(product.id),
                noInventoryText: this.noInventoryTextHandler(),
                isMatrixProduct: !!product.is_matrix_product,
                isBundle: product.type == "bundle",
                minimalistInventoryVisible: this.showMinimalistInventory(product),
            });
        },

        // #111887: the matrix "In Stock"/"Out of Stock" badge reads the inventory
        // map directly, so it is gated the same way as the fallback badge above.
        showMatrixStockBadge(product) {
            return shouldShowMatrixStockBadge({
                inventoriesLoaded: this.inventoriesLoaded,
                isMatrixProduct: !!product.is_matrix_product,
                minimalistInventoryVisible: this.showMinimalistInventory(product),
            });
        },
        getProductAllowBackorder(product) {
            if (!this.hasWarehouse) return false;
            if (product.type == "variable") {
                if (product.default_variation) {
                    return product.default_variation.allow_backorders;
                } else if (product.base_variation) {
                    return product.base_variation.allow_backorders;
                }
            }
            return false;
        },
        getProductWarehouseInventory(product) {
            let productWarehouseInventory = this.user_warehouse_inventories[product.id];

            if (this.isEmpty(productWarehouseInventory)) {
                return null;
            }

            let selectedProduct = this.selectProduct(product);
            if (this.isEmpty(selectedProduct)) return null;


            return this.getStockBalance(productWarehouseInventory, selectedProduct);
        },
        getStockBalance(warehouseInventory, variation) {
            if (this.isEmpty(variation) || !variation.conv_rate) {
                return window.bo.productTranslations.out_of_stock;
            }

            if (window.bo.hasCapabilityPhysical) {
                let sellable = this.roundToDecimal(warehouseInventory.balance / variation.conv_rate);
                let physical = this.roundToDecimal(warehouseInventory.physical_balance / variation.conv_rate);
                return sellable + "s / " + physical + "p";
            }
            if (window.bo.hasCapabilitySellable) {
                return window.bo.productTranslations.amount_in_stock.replace(
                    ":amount",
                    this.roundToDecimal(warehouseInventory.balance / variation.conv_rate)
                );
            }
            if (window.bo.hasCapabilityRoughSellable) {
                let roughStockMessage = "";

                for (let i = 0; i < this.roughStocks.length; i++) {
                    let balance = this.roundToDecimal(warehouseInventory.balance / variation.conv_rate);
                    if (this.roughStocks[i]["comparison"] == ">") {
                        if (balance > this.roughStocks[i]["quantity"]) {
                            roughStockMessage = this.roughStocks[i]["display_as"];
                            break;
                        }
                    } else if (this.roughStocks[i]["comparison"] == "<") {
                        if (balance < this.roughStocks[i]["quantity"]) {
                            roughStockMessage = this.roughStocks[i]["display_as"];
                            break;
                        } else {
                            roughStockMessage = balance + " in Stock";
                            break;
                        }
                    }
                }

                return roughStockMessage;
            }

            if (warehouseInventory.balance > 0) return window.bo.productTranslations.in_stock;
            return window.bo.productTranslations.out_of_stock;
        },
        roundToDecimal(number, decimal = 2) {
            return parseFloat(Number(number).toFixed(decimal));
        },
        getStockClass(product, user_warehouse_inventories) {
            if (user_warehouse_inventories[product?.id] == null) return "";

            const stockBalance = user_warehouse_inventories[product.id]?.stock_balance;
            const stockBalanceId = user_warehouse_inventories[product.id]?.stock_balance_id;
            const balance = user_warehouse_inventories[product.id]?.balance;
            const physicalBalance = user_warehouse_inventories[product.id]?.physical_balance;

            switch (true) {
                case stockBalanceId == "out_of_stock" || stockBalance.includes("Less than"):
                    return "danger";
                case balance <= 0 && physicalBalance <= 0:
                    return "danger";
                case balance <= 0 && physicalBalance > 0:
                    return "warning";
                case balance > 0 && physicalBalance <= 0:
                    return "warning";
                case balance > 0 && physicalBalance > 0:
                    return "success";
                default:
                    return "";
            }
        },
        showMinimalistInventory(product) {
            if (product.is_matrix_product === true) {
                return (
                    // don't show when product out of stock and backorder allowed
                    !(this.getProductAllowBackorder(product) === true && !this.getMatrixProductStockInStatus(product))
                );
            } else {
                return (
                    this.showMinimalistStock === false ||
                    // don't show when product out of stock and backorder allowed
                    !(
                        this.getProductAllowBackorder(product) === true &&
                        (!this.productInventoryExists(product.id) ||
                            this.user_warehouse_inventories[product.id].stock_balance_id === "out_of_stock")
                    )
                );
            }
        },
        showMinimalistBackorder(product) {
            if (product.is_matrix_product === true) {
                return (
                    // don't show when product out of stock and backorder allowed
                    !(this.getProductAllowBackorder(product) === true && this.getMatrixProductStockInStatus(product))
                );
            } else {
                return (
                    this.showMinimalistStock === false ||
                    // don't show when product in stock and backorder allowed
                    !(
                        this.getProductAllowBackorder(product) === true &&
                        this.productInventoryExists(product.id) &&
                        this.user_warehouse_inventories[product.id].stock_balance_id === "in_stock"
                    )
                );
            }
        },
        activateProductMatrixPopup(event, product) {
            if (event.target.classList.contains("variation-selection")) {
                event.preventDefault();
                this.getProduct(product.id, window.bo.productsUrl, {}, (product) => {
                    this.matrixProduct = product;
                    this.activeProductMatrixPopup = true;
                    if (success) success(this.products);
                });
            }
        },
        getMatrixProductStockInStatus(product) {
            return Object.values(this.user_warehouse_inventories).some((warehouseInventory) => {
                if (warehouseInventory.product_parent_id == product.id && warehouseInventory.balance > 0) {
                    return true;
                }
                return false;
            });
        },
        getMatrixStockClass(product) {
            if (this.getMatrixProductStockInStatus(product)) {
                return "success";
            }
            return "danger";
        },
        selectProductCategory(productCategoryId) {
            this.$emit("product_category_id", productCategoryId);
        },
        getPageNumber(url) {
            if (this.isSearching) {
                window.location.assign(url);
            } else {
                let pageParamIndex = url.indexOf("&page=");
                if (pageParamIndex !== -1) {
                    let pageNumber = parseInt(url.substr(pageParamIndex + 6), 10);

                    if (!isNaN(pageNumber)) {
                        this.selectPage(pageNumber, null);
                    }
                }
            }
        },
        selectPage(pageNumber, links = null) {
            if (this.isSearching) {
                this.goToPage(links);
            } else {
                this.$emit("catalog_page_number", pageNumber);
            }
        },

        favoriteProduct(product, index) {
            this.postData(
                window.bo.favoriteProductUrl,
                { product_id: product.id },
                (response) => {
                    let message =
                        response?.data ??
                        `<span style="color: #007AFF; font-weight: 600;">1</span> item(s) were updated.`;

                    this.$emit("show_snackbar", message);
                },
                (failure) => {
                    this.products.data[index]["favorited"] = !this.products.data[index]["favorited"];

                    if (failure?.response?.data?.errors?.code == "user_not_login") {
                        this.$emit("show_login", true);
                    } else {
                        this.$emit(
                            "show_snackbar",
                            "<span style='color:#FF0000';>" + failure?.response?.data?.message + "</span>",
                            true
                        );
                    }
                },
                false
            );
        },

        quickAddProduct(product) {
            if (product.type == "bundle") {
                window.location.href = product.product_details_url;
            } else {
                this.$emit("active_quick_add_popup", product);
            }
        },

        // Price block (bo-price-display) for a catalog product: discounted price, tax tag and points on top,
        // original price and discount levels below. A bundle parent always shows the effective percentage.
        getCatalogPriceDisplay(product) {
            const display = buildCatalogPriceDisplay(product, {
                taxExempted: this.taxExempted,
                taxIncluded: this.taxIncluded,
                displayIncludingTax: this.displayPricesDuringCartAndCheckoutIncludingTax,
                hideLineItemTax: this.hideLineItemTax,
                currencySymbol: this.currencySymbol,
                fromLabel: this.catalogTranslations.from,
            });

            return {
                ...display,
                point: this.calculatePoint(display.price),
                showPoint: this.pointConfig != false,
            };
        },
    },
};
</script>
